var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "70 Basic icons by Xicons.co") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42,48H6a2,2,0,0,1-2-2V35.61a2.07,2.07,0,0,1,1.66-2.08A2,2,0,0,1,8,35.5V44H40V35.61a2.07,2.07,0,0,1,1.66-2.08,2,2,0,0,1,2.34,2V46A2,2,0,0,1,42,48Z",
    fill: "#4dbe86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,37a2,2,0,0,1-2-2V2a2,2,0,0,1,4,0V35A2,2,0,0,1,24,37Z",
    fill: "#4dbe86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,38a2.07,2.07,0,0,1-1.44-.59l-14-14a2,2,0,0,1,2.83-2.83L24,33.19l12.61-12.6a2,2,0,0,1,2.83,2.83l-14,14A2,2,0,0,1,24,38Z",
    fill: "#4dbe86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.89ea36642a1685e6d8bb6503ad815355.svg";
export { ForwardRef as ReactComponent };